import React from 'react';
import clsx from 'clsx';
import styles from './Textarea.module.scss';

type Props = {
  name?: string;
  value?: string;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  rows?: number;
};

const Textarea = React.forwardRef<HTMLTextAreaElement, Props>((props, ref): JSX.Element => {
  const {
    name,
    value,
    disabled = false,
    placeholder,
    className,
    rows,
    ...other
  } = props;

  return (
    <textarea
      ref={ref}
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      className={clsx(styles.root, className)}
      rows={rows}
      {...other}
    >
    </textarea>
  );
});

export default React.memo(Textarea);